export default {"src":"/_next/static/media/zoom-out.5c5c7a85.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};